module.exports = __webpack_public_path__ + "img/ms_out.bbd1c0e8.png";